<template lang="pug">
	.card.text-left
		.card-header.bg-info.text-white Búsqueda de clientes
		.card-body
			.row
				.col-xs-12.col-sm-6.col-md-3.col-lg-3
					.form-group.form-group-sm
						label Agente
						input.form-control.form-control-sm(type="text" v-model="filtro.agente" @keypress.enter="buscar" placeholder="Busca por agente")
					.form-group.form-group-sm(v-if="!permisos.clientes_verTodos")
						label Agente
						input.form-control.form-control-sm(type="text" :value="usuario.nombre" disabled)
					div.form-group.form-group-sm
						label Nombre/CIF
						input.form-control.form-control-sm(type="text" v-model="filtro.nombre" @keypress.enter="buscar" placeholder="Busca por nombre o CIF")
				div.col-xs-12.col-sm-6.col-md-3.col-lg-3
					div.form-group.form-group-sm
						label Activo
						br
						.btn-group
							button.btn.btn-sm(:class="(filtro.activo === null) ? 'btn-primary' : 'btn-default'" @click="filtro.activo = null") Todos
							button.btn.btn-sm(:class="(filtro.activo === true) ? 'btn-primary' : 'btn-default'" @click="filtro.activo = true") Activo
							button.btn.btn-sm(:class="(filtro.activo === false) ? 'btn-primary' : 'btn-default'" @click="filtro.activo = false") Inactivo
					div.form-group.form-group-sm
						label Asignado
						br
						.btn-group
							button.btn.btn-sm(:class="(filtro.asignado === null) ? 'btn-primary' : 'btn-default'" @click="filtro.asignado = null") Ambos
							button.btn.btn-sm(:class="(filtro.asignado === true) ? 'btn-primary' : 'btn-default'" @click="filtro.asignado = true") Sí
							button.btn.btn-sm(:class="(filtro.asignado === false) ? 'btn-primary' : 'btn-default'" @click="filtro.asignado = false") No
				.col-xs-12.col-sm-6.col-md-3.col-lg-3
					.row
						.col
							.form-group.form-group-sm
								label Semáforo contratos
								br
								.btn-group
									button.btn.btn-sm(:class="(filtro.semaforoContratos === null) ? 'btn-primary' : 'btn-default'" @click="filtro.semaforoContratos = null") Todos
									button.btn.btn-sm(:class="(filtro.semaforoContratos === 'verde') ? 'btn-success' : 'btn-default'" @click="filtro.semaforoContratos = 'verde'") Verde
									button.btn.btn-sm(:class="(filtro.semaforoContratos === 'naranja') ? 'btn-warning' : 'btn-default'" @click="filtro.semaforoContratos = 'naranja'") Naranja
									button.btn.btn-sm(:class="(filtro.semaforoContratos === 'rojo') ? 'btn-danger' : 'btn-default'" @click="filtro.semaforoContratos = 'rojo'") Rojo
						.col
							.form-group.form-group-sm
								label Semáforo propuestas
								br
								.btn-group
									button.btn.btn-sm(:class="(filtro.semaforoPropuestas === null) ? 'btn-primary' : 'btn-default'" @click="filtro.semaforoPropuestas = null") Todos
									button.btn.btn-sm(:class="(filtro.semaforoPropuestas === 'verde') ? 'btn-success' : 'btn-default'" @click="filtro.semaforoPropuestas = 'verde'") Verde
									button.btn.btn-sm(:class="(filtro.semaforoPropuestas === 'naranja') ? 'btn-warning' : 'btn-default'" @click="filtro.semaforoPropuestas = 'naranja'") Naranja
									button.btn.btn-sm(:class="(filtro.semaforoPropuestas === 'rojo') ? 'btn-danger' : 'btn-default'" @click="filtro.semaforoPropuestas = 'rojo'") Rojo
					div.form-group.form-group-sm
						.row
							.col
								label Con facturación
								br
								.btn-group
									button.btn.btn-sm(:class="(filtro.facturacion === null) ? 'btn-primary' : 'btn-default'" @click="filtro.facturacion = null") Ambas
									button.btn.btn-sm(:class="(filtro.facturacion === true) ? 'btn-primary' : 'btn-default'" @click="filtro.facturacion = true") Sí
									button.btn.btn-sm(:class="(filtro.facturacion === false) ? 'btn-primary' : 'btn-default'" @click="filtro.facturacion = false") No
							.col(v-if="permisos.clientes_crearTodos")
								label Geolocalizados
								br
								.btn-group
									button.btn.btn-sm(:class="(filtro.Google === null) ? 'btn-primary' : 'btn-default'" @click="filtro.Google = null") Ambos
									button.btn.btn-sm(:class="(filtro.Google === '1') ? 'btn-primary' : 'btn-default'" @click="filtro.Google = '1'") Sí
									button.btn.btn-sm(:class="(filtro.Google === '0') ? 'btn-primary' : 'btn-default'" @click="filtro.Google = '0'") No
				div.col-xs-12col-sm-6col-md-3col-lg-3
					div.form-group.form-group-sm
						label Límite de resultados
						br
						.btn-group
							button.btn.btn-sm(:class="(filtro.max === 50) ? 'btn-primary' : 'btn-default'" @click="filtro.max = 50") 50
							button.btn.btn-sm(:class="(filtro.max === 250) ? 'btn-primary' : 'btn-default'" @click="filtro.max = 250") 250
							button.btn.btn-sm(:class="(filtro.max === 500) ? 'btn-primary' : 'btn-default'" @click="filtro.max = 500") 500
							button.btn.btn-sm(:class="(filtro.max === null) ? 'btn-primary' : 'btn-default'" @click="filtro.max = null") Sin límite
					.form-group
						label Ordenar resultados
						.input-group.inout-group-sm
							.input-group-prepend
								.input-group-text Campo
							select.form-control(v-model="filtro.ordenarCampo")
								option(v-for="campo in listadoCampos", :key="campo.campo", :value="campo.campo") {{campo.nombre}}
							.input-group-append.input-group-prepend
								button.btn.btn-sm(@click="filtro.ordenarOrden = 'ASC'", :class="(filtro.ordenarOrden === 'ASC') ? 'btn-primary' : ''")
									span.fa.fa-caret-up
							.input-group-append
								button.btn.btn-sm(@click="filtro.ordenarOrden = 'DESC'", :class="(filtro.ordenarOrden === 'DESC') ? 'btn-primary' : ''")
									span.fa.fa-caret-down
		.card-footer
			button.btn.btn-sm.btn-primary.mr-2(@click="buscar()")
				span.fa.fa-search.mr-2
				| Buscar
			button.btn.btn-sm.btn-warning(@click="nuevo()")
				span.fa.fa-edit.mr-2
				| Nuevo
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	props: ['filtro'],
	data: function () {
		return {
			listadoCampos: [
				{
					nombre: 'Agente',
					campo: 'agente.nombre'
				},
				{
					nombre: 'Cliente',
					campo: 'cliente.cliente'
				},
				{
					nombre: 'Fecha de creación',
					campo: 'cliente.fecha_creacion'
				},
				{
					nombre: 'CIF',
					campo: 'cliente.CIF'
				},
				{
					nombre: 'Facturación',
					campo: 'cliente.importe_facturado'
				},
				{
					nombre: 'Semáforo',
					campo: 'cliente.dias_sin_campana'
				}
			]
		}
	},
	name: 'filtro-listado',
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		})
	},
	methods: {
		buscar () {
			this.$emit('buscar')
		},
		nuevo () {
			this.$emit('nuevo')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/components/listado/listado-filtro.vue